import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AnalyticsProvider from './components/AnalyticsProvider';
// Import the new FixedNavbar component
import FixedNavbar from './components/FixedNavbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import WealthManagementPage from './pages/WealthManagementPage';

function App() {
  return (
    <AnalyticsProvider>
      <div className="min-h-screen flex flex-col">
        <FixedNavbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/wealth-management" element={<WealthManagementPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </AnalyticsProvider>
  );
}

export default App;